function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// region import React
import React from 'react';
// endregion
// region import components
import { PureShareButtons } from '@ta-interaktiv/react-share-buttons'; // endregion
// region import CSS
// Semantic UI

import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'; // Specific CSS

import '../style/Masthead.css';

/**
 * Renders the masthead component.
 *
 * @example
 * import { PureMasthead } from '@ta-interaktiv/react-masthead';
 *
 *  // ...
 *
 *  class YourComponent extends React.Component {
 *   render() {
 *
 *     return (
 *       <Masthead
 *          mediaName='tagesanzeiger'
 *          homepage='//www.tagesanzeiger.ch'
 *          fullMediaName='Tages-Anzeiger'
 *          hashtags={['TAGrafik', 'DDJ']} />
 *     )
 *   }
 * }
 *
 * @example <caption>You may add additional content into the header that will
 *   be displayed on desktop devices</caption>
 * <Masthead>
 *   <div className='ui small infographic orange header'>WebSpezial</div>
 * </Masthead>
 *
 * @param {object} props
 * @param {string} [props.mediaName=tagesanzeiger] The media domain name whose
 * logo should be shown.
 * @param {string} [props.fullMediaName=Tages-Anzeiger] The outwards facing
 *   media name.
 * @param {string} [props.homepage=http://www.tagesanzeiger.ch] The home page
 *   of the medium to link to.
 * @param {string} [props.url] The URL to share. Will be
 * overridden by URLs in the {@link communities} array. Passed along to share
 *   buttons component. Default is set through share buttons and defaults to
 *   the window.location.origin and window.location.pathname (removing any
 *   query parameters and hashes).
 * @param {boolean} [props.inverted=false] Whether the masthead should be
 * displayed inverted, for use on dark backgrounds.
 * @param {string[]} [props.hashtags] Hashtags as an array of strings. Facebook
 *   will only use the first one.
 * @param {Community[]} [props.communities] Community objects, as
 * provided by the External Services API service by Newsnet.
 * @param {function} [props.clickHandler=noop] The action that should be
 * executed when the user clicks the link.
 * @param {React.Node} [props.children] Add content to be displayed in the
 * middle column (like a series marker).
 */
export default function Masthead(props) {
  // Set up defaults
  var _props$mediaName = props.mediaName,
      mediaName = _props$mediaName === void 0 ? 'tagesanzeiger' : _props$mediaName,
      _props$inverted = props.inverted,
      inverted = _props$inverted === void 0 ? false : _props$inverted,
      _props$clickHandler = props.clickHandler,
      clickHandler = _props$clickHandler === void 0 ? function () {} : _props$clickHandler,
      _props$homepage = props.homepage,
      homepage = _props$homepage === void 0 ? '//www.tagesanzeiger.ch' : _props$homepage,
      _props$fullMediaName = props.fullMediaName,
      fullMediaName = _props$fullMediaName === void 0 ? 'Tages-Anzeiger' : _props$fullMediaName,
      url = props.url; // Prepare constants for the inverted version

  var invertedClass = inverted ? 'inverted' : '';
  var invertedImgSrcName = inverted ? '-inverted' : '';
  return React.createElement("div", {
    className: "ta-masthead masthead-component ".concat(invertedClass)
  }, React.createElement("div", {
    className: "ui container "
  }, React.createElement("div", {
    className: "ui middle aligned grid"
  }, React.createElement("div", {
    className: "mobile only three wide column ta-logo"
  }, React.createElement("a", {
    href: homepage
  }, ' ', React.createElement("img", {
    src: "//interaktiv.tagesanzeiger.ch/static/icons/".concat(mediaName).concat(invertedImgSrcName, ".svg"),
    alt: fullMediaName,
    className: "ui middle aligned logo image"
  }), ' ')), React.createElement("div", {
    className: "mobile hidden five wide column ta-logo"
  }, React.createElement("a", {
    href: homepage
  }, React.createElement("img", {
    src: "//interaktiv.tagesanzeiger.ch/static/logos/".concat(mediaName).concat(invertedImgSrcName, ".svg"),
    alt: fullMediaName,
    className: "ui logo image"
  }))), React.createElement("div", {
    className: "center aligned mobile hidden six wide column"
  }, props.children), React.createElement("div", {
    className: "right aligned right floated thirteen wide mobile five wide tablet five wide computer column"
  }, React.createElement(PureShareButtons, _extends({}, props, {
    url: url,
    clickHandler: clickHandler,
    displayType: "horizontal icons"
  }))))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-masthead/es/pureMasthead.js
// module id = null
// module chunks = 